export interface WrapperConfig {
  network: NetworkConfig;
  contracts?: ContractConfig[];
  options?: any;
}


export interface NetworkConfig {
  portal: string;
  rpc: string;
  chainId?: number;
}

export interface ContractConfig {
  name: string;
  address: string;
  abi: any[];
  network?: string;
}

export interface SessionData {
  walletAddress: string;
  chainId: number;
  lastConnected: string;
  permissions: string[];
  sessionId: string;
}

export interface TransactionRequest {
  to: string;
  data?: string;
  value?: string;
  gasLimit?: string;
  gasPrice?: string;
}

export interface TransactionResponse {
  hash: string;
  wait: () => Promise<TransactionReceipt>;
}

export interface TransactionReceipt {
  transactionHash: string;
  blockNumber: number;
  gasUsed: string;
  status: number;
}

export interface ContractMethod {
  name: string;
  inputs: any[];
  outputs: any[];
  stateMutability: string;
  type: 'function';
}

export interface ContractEvent {
  name: string;
  inputs: any[];
  anonymous: boolean;
  type: 'event';
}

export interface ContractError {
  name: string;
  inputs: any[];
  type: 'error';
}

export interface ContractConstructor {
  inputs: any[];
  stateMutability: string;
  type: 'constructor';
}

export interface ContractReceive {
  stateMutability: 'payable';
  type: 'receive';
}

export interface ContractFallback {
  stateMutability: string;
  type: 'fallback';
}

export type AbiItem = ContractMethod | ContractEvent | ContractError | ContractConstructor | ContractReceive | ContractFallback;

export interface ParsedABI {
  functions: ContractMethod[];
  events: ContractEvent[];
  errors: ContractError[];
  constructor?: ContractConstructor;
  receive?: ContractReceive;
  fallback?: ContractFallback;
}

export interface WrapperError extends Error {
  code: string;
  details?: any;
}

export enum ErrorCodes {
  WALLET_NOT_CONNECTED = 'WALLET_NOT_CONNECTED',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  USER_REJECTED = 'USER_REJECTED',
  NETWORK_ERROR = 'NETWORK_ERROR',
  CONTRACT_NOT_FOUND = 'CONTRACT_NOT_FOUND',
  INVALID_ADDRESS = 'INVALID_ADDRESS',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  MOBILE_NOT_SUPPORTED = 'MOBILE_NOT_SUPPORTED'
}
